__turbopack_context__.v({
  "Close": "_0tBiJG_Close",
  "Down": "_0tBiJG_Down",
  "Heading": "_0tBiJG_Heading",
  "Open": "_0tBiJG_Open",
  "RegionButton": "_0tBiJG_RegionButton",
  "RegionExpander": "_0tBiJG_RegionExpander",
  "RegionInnerContainer": "_0tBiJG_RegionInnerContainer",
});
